import React from 'react';
import { Typography, Card, Row, Col, Tag } from 'antd';
import { RefLanguage } from '../hooks/LanguageHooks';

const { Title, Paragraph } = Typography;

function DocsMethodsPage() {
    const i18n = RefLanguage();

    return (
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
            <Typography>
                <Title level={2}>{i18n.t("docsMethodsTitle")}</Title>
                
                <Paragraph style={{ fontSize: '16px', marginBottom: '32px' }}>
                    {i18n.t("docsMethodsIntro")}
                </Paragraph>

                <Row gutter={[24, 24]}>
                    <Col xs={24} lg={12}>
                        <Card title="BLASTn" size="small">
                            <Tag color="blue" style={{ marginBottom: '8px', fontSize: '15px', padding: '2px 8px' }}>Sensitive</Tag>
                            <Paragraph>
                                {i18n.t("docsMethodsBlastn")}
                            </Paragraph>
                        </Card>
                    </Col>
                    
                    <Col xs={24} lg={12}>
                        <Card title="MegaBLAST" size="small">
                            <Tag color="green" style={{ marginBottom: '8px', fontSize: '15px', padding: '2px 8px' }}>Fast</Tag>
                            <Paragraph>
                                {i18n.t("docsMethodsMegablast")}
                            </Paragraph>
                        </Card>
                    </Col>
                    
                    <Col xs={24} lg={12}>
                        <Card title="VSEARCH Global" size="small">
                            <Tag color="orange" style={{ marginBottom: '8px', fontSize: '15px', padding: '2px 8px' }}>End-to-end</Tag>
                            <Paragraph>
                                {i18n.t("docsMethodsVsearchGlobal")}
                            </Paragraph>
                        </Card>
                    </Col>
                    
                    <Col xs={24} lg={12}>
                        <Card title="VSEARCH Exact" size="small">
                            <Tag color="red" style={{ marginBottom: '8px', fontSize: '15px', padding: '2px 8px' }}>Exact match</Tag>
                            <Paragraph>
                                {i18n.t("docsMethodsVsearchExact")}
                            </Paragraph>
                        </Card>
                    </Col>
                </Row>

            {/*
                <Title level={3} style={{ marginTop: '48px' }}>
                    {i18n.t("docsMethodsSelectionTitle")}
                </Title>
                
                <Paragraph>
                    {i18n.t("docsMethodsSelectionText")}
                </Paragraph>
            */}   
         
            </Typography>
        </div>
    );
}

export default DocsMethodsPage;
